const BILLING_TYPE_BY_PAYMENT_METHOD = {
  credit_card: 'CREDIT_CARD',
  pix: 'PIX',
  boleto_pix: 'BOLETO'
}

export const PAYMENT_METHODS = Object.keys(BILLING_TYPE_BY_PAYMENT_METHOD)

export function billingTypeForPaymentMethod (paymentMethod) {
  const billingType = BILLING_TYPE_BY_PAYMENT_METHOD[paymentMethod]
  if (!billingType) throw new Error(`Forma de pagamento inválida: ${paymentMethod}`)
  return billingType
}



// WEBPACK FOOTER //
// ./src/utils/billing-type.js